// Same as front-end/src/components/logo/LogoIcon.tsx, minus the per-company logo.
import useConfig from "hooks/useConfig";
import { ThemeMode } from "types/config";
import { nuwaySymbol } from "./brand";

// ==============================|| LOGO ICON SVG ||============================== //

const LogoIcon = () => {
  const { mode } = useConfig();
  return (
    <img
      src={nuwaySymbol(mode === ThemeMode.DARK)}
      alt="Nuway"
      width={"36"}
      height={"36"}
    />
  );
};

export default LogoIcon;
